import * as Sentry from '@sentry/vue'

import LogsService from '../../services/LogsService'
import { getFirebaseLocalStorageEntry } from '../../util/index_db_helper'

type CustomLogger = {
  message: string
  level?: 'error' | 'info'
  indexName?: string
  tags?: any  // Sentry will reject a few tags, but we will log them to ES anyway
  excludeFromESLogger?: boolean,
  excludeFromSentry?: boolean
}

// Store recent error logs

// Define a fixed-size array for error logs
const MAX_ERROR_LOGS = 20;
const errorLogs = new Array(MAX_ERROR_LOGS);
let errorLogIndex = 0;

function addErrorLog(event, errorType: 'Error' ) {

  if (!event?.message?.toLowerCase().includes('firebase')) {
    return;
  }

  const errorMsg = `${errorType}: ${event?.message} at ${event?.filename}:${event?.lineno}:${event?.colno}`;
  
  // Add to circular buffer without using push/shift (more efficient)
  errorLogs[errorLogIndex] = errorMsg;
  errorLogIndex = (errorLogIndex + 1) % MAX_ERROR_LOGS;

  if (event.error && event.error.stack) {
    errorLogs[errorLogIndex] = `Stack: ${event.error.stack}`;
    errorLogIndex = (errorLogIndex + 1) % MAX_ERROR_LOGS;
  }
}

// Helper function to get all error logs in chronological order
export const getErrorLogs = (): string => {
  // Reconstruct the logs in chronological order from the circular buffer
  return [...errorLogs.slice(errorLogIndex), ...errorLogs.slice(0, errorLogIndex)]
    .filter(Boolean) // Remove undefined entries
    .join('\n');
}

// Capture errors using event listener
window.addEventListener('error', (event) => {
  addErrorLog(event, 'Error');
});



/**
 * This will log to sentry only in PROD otherwise mentioned in ALLOWED_ENV.
 * ESLogger will log to ES in all environments.
 */
export const customLogger = ({ indexName = 'firebase-token-issues', message, level = 'info', tags, excludeFromESLogger = false, excludeFromSentry = false }: CustomLogger) => {
  try {
    // Add error logs to extra data if they exist
    const errorLogsData = getErrorLogs();
    const extraData = errorLogsData ? { errorLogs: errorLogsData } : {};
    
    if (level === 'error' && !excludeFromSentry) {
      Sentry.captureException(message, {
        tags,
        extra: extraData
      })
    }

    if (!excludeFromESLogger) {
     //We fetching this to check state of firebase indexedDB to see if it is corrupted and that has caused this issue
     //Using .then to avoid change parent method to async as it is already sync and used at multiple places
      //Consciously not 'async/await'
      LogsService.dump(indexName, {
        ...tags,
        page: window?.location?.href,
        instance: message,
        level,
        ...(errorLogs?.length > 0 ? { errorLogs: errorLogsData } : {})
      })
    }
  } catch (error) {
    console.error('Error in customLogger', error)
  }

  // Just in case
  if(excludeFromSentry && excludeFromESLogger) {
    console.warn(message, tags)
  }
}
